export interface QueueLockedType {
  numberOfOldCredits: number
  numberOfOldPosts: number
  queuedPostsCount: number
  postsIncluded: number
}

const statesMap = {
  pending: 'pending',
  active: 'active',
  canceled: 'canceled',
  expired: 'expired',
  paused: 'paused'
}

const customerContexts = {
  current: [
    statesMap.active,
    statesMap.canceled,
    statesMap.paused
  ]
}

export type CContext = keyof typeof statesMap | keyof typeof customerContexts;

function customerInContext(c: { state: string }, contextOrState: CContext): boolean {
  return customerContexts.hasOwnProperty(contextOrState) ?
    customerContexts[contextOrState].indexOf(c.state) >= 0 :
    c.state === contextOrState
}

function queueLocked(c: QueueLockedType): boolean {
  return c.numberOfOldCredits > 0 && c.numberOfOldPosts > 0 && c.queuedPostsCount > 2 * c.postsIncluded
}

export { customerInContext, queueLocked }
